import { MODAL_STATUS } from '../actions';

const INIT_STATE = {
    type: null,
    data: null,
    state: false,
};

const modalsReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case MODAL_STATUS:
            return { ...state, ...action.payload };
        default:
            return { ...state };
    }
};

export default modalsReducer;
